"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.haversineDistanceInMiles = exports.haversineDistanceInKilometers = exports.haversineDistance = exports.getDestination = void 0;
const commons_objects_1 = require("@deliverr/commons-objects");
const AddressUtils_1 = require("./AddressUtils");
const getDestination = (tags, address) => {
    if ((0, AddressUtils_1.isMilitaryAddress)(address) || (0, AddressUtils_1.isAddressInAkHiOther)(address)) {
        return commons_objects_1.Destination.NON_CONTIGUOUS_US;
    }
    if (tags.includes(commons_objects_1.OrderTag.INTERNATIONAL_ORDER)) {
        return commons_objects_1.Destination.INTERNATIONAL;
    }
    return commons_objects_1.Destination.CONTIGUOUS_US;
};
exports.getDestination = getDestination;
const haversineDistance = (originCoordinates, destinationCoordinates) => {
    return (0, exports.haversineDistanceInKilometers)(originCoordinates, destinationCoordinates);
};
exports.haversineDistance = haversineDistance;
const haversineDistanceInKilometers = (originCoordinates, destinationCoordinates) => {
    const radiusKm = 6371;
    return radiusKm * archaversine(originCoordinates, destinationCoordinates);
};
exports.haversineDistanceInKilometers = haversineDistanceInKilometers;
const haversineDistanceInMiles = (originCoordinates, destinationCoordinates) => {
    const radiusMiles = 3961;
    return radiusMiles * archaversine(originCoordinates, destinationCoordinates);
};
exports.haversineDistanceInMiles = haversineDistanceInMiles;
const archaversine = (originCoordinates, destinationCoordinates) => {
    function degreesToRad(degrees) {
        return (degrees * Math.PI) / 180;
    }
    const lon1 = originCoordinates.lng;
    const lat1 = originCoordinates.lat;
    const lon2 = destinationCoordinates.lng;
    const lat2 = destinationCoordinates.lat;
    const x1 = lat2 - lat1;
    const dLat = degreesToRad(x1);
    const x2 = lon2 - lon1;
    const dLon = degreesToRad(x2);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(degreesToRad(lat1)) * Math.cos(degreesToRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
//# sourceMappingURL=DestinationUtils.js.map